/* eslint-disable curly, no-unused-expressions, no-magic-numbers */

/**
 * @module AgreeForm
 */
class AgreeForm {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._state = {
            valid: false
        };

        this._rootContainer = document.body;

        this._elements = {
            checkbox: this._element.querySelector('input[type="checkbox"]'),
            submit: this._element.querySelector('.cta')
        };

        this._checkValidity = this._checkValidity.bind(this);
        this._switchSubmit = this._switchSubmit.bind(this);

        this._initialize();
    }

    /**
     * Initialize
     */
    _initialize() {

        this._checkValidity();
        this._elements.checkbox.addEventListener('change', this._checkValidity);
    }


    /**
     * Enable/Disable submit button
     * @private
     */
    _switchSubmit() {
        this._state.valid && this._elements.submit.removeAttribute('disabled');
        !this._state.valid && this._elements.submit.setAttribute('disabled', '');
    }

    /**
     * Check if the checkbox is checked
     * @private
     */
    _checkValidity() {
        const disabled = !this._elements.checkbox.checked;
        this._state.valid = !disabled;
        this._switchSubmit();
    }
}

export default AgreeForm;
/* eslint-enable */
